import type {
  GalleryPostStatus,
  GalleryReactionKind,
  GalleryReportReason,
} from "@canvaschool/contracts";

export const REACTIONS: ReadonlyArray<{
  kind: GalleryReactionKind;
  emoji: string;
  label: string;
}> = [
  { kind: "LIKE", emoji: "❤️", label: "좋아요" },
  { kind: "AWESOME", emoji: "👏", label: "멋져요!" },
  { kind: "COLOR", emoji: "🎨", label: "색이 예뻐요" },
  { kind: "IDEA", emoji: "💡", label: "아이디어 최고" },
  { kind: "FUNNY", emoji: "😂", label: "재밌어요" },
];

export const REPORT_REASONS: ReadonlyArray<{
  reason: GalleryReportReason;
  label: string;
}> = [
  { reason: "PERSONAL_INFO", label: "개인정보가 보여요" },
  { reason: "INAPPROPRIATE", label: "부적절한 그림이에요" },
  { reason: "OTHER", label: "기타" },
];

export const REPORT_REASON_LABEL: Record<GalleryReportReason, string> = {
  PERSONAL_INFO: "개인정보",
  INAPPROPRIATE: "부적절",
  OTHER: "기타",
};

export const POST_STATUS_LABEL: Record<GalleryPostStatus, string> = {
  PUBLISHED: "공개 중",
  WITHDRAWN: "학생이 내림",
  REMOVED_BY_TEACHER: "선생님이 내림",
  HIDDEN: "신고로 숨김",
  DELETED: "운영자가 삭제",
};

export const reactionTotal = (
  reactions: Record<GalleryReactionKind, number>,
): number => REACTIONS.reduce((sum, { kind }) => sum + reactions[kind], 0);
